"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStatus = void 0;
var GameStatus;
(function (GameStatus) {
    GameStatus["SCHEDULED"] = "SCHEDULED";
    GameStatus["IN_PROGRESS"] = "IN_PROGRESS";
    GameStatus["FINISHED"] = "FINISHED";
    GameStatus["FINALIZED"] = "FINALIZED";
    GameStatus["CANCELLED"] = "CANCELLED";
    // STANDALONE is used for displaying dummy game component with no interaction
    GameStatus["STANDALONE"] = "STANDALONE";
})(GameStatus || (exports.GameStatus = GameStatus = {}));
